import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

const BreadCrumb = ({ items  }) => {
    return (
        <React.Fragment>
            <Row>
                <Col xs={12}>
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0">{items[items.length - 1].title}</h4>

                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                            {items.map((item, index) => (
                                    <li key={index} className={`breadcrumb-item ${index === items.length - 1 ? 'active' : ''}`}>
                                        {index === items.length - 1 ? (
                                            item.title
                                        ) : (
                                            <Link to={item.link}>{item.title}</Link>
                                        )}
                                    </li>
                                ))}
                            </ol>
                        </div>

                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default BreadCrumb;